import React from 'react';
import LoadSuccessIcon from '../../assets/svgs/LoadSuccessIcon.svg.js';
export default function determineIcon(loading, isComplete, iconStart) {
    if (isComplete && !loading) {
        return React.createElement(LoadSuccessIcon, { className: 'kal-tick-icon' });
    }
    return iconStart;
}
//# sourceMappingURL=determineIcon.js.map